import { Link, useNavigate, useLocation } from 'react-router-dom';
import DeleteAccountPanel from './DeleteAccountPanel';
import '../App.css';

// Account deletion. Google Play's User Data policy requires that any app
// allowing account creation also allows deletion, AND that the route is
// reachable from the open web — someone who has uninstalled the app must still
// be able to get here. Hence this public page (route /delete-account) rather
// than only the in-profile entry point. The deletion flow itself lives in
// DeleteAccountPanel, shared with ProfilePage so the logic isn't duplicated.
const bloomMark = process.env.PUBLIC_URL + '/BloomFavicon.png';

// Same top bar as the dashboards, but constrained to the narrow column so it
// lines up with the content beneath it. The wordmark is a link home rather than
// an <h1> — the page's own <h1> is the title of the page.
const DeleteHeader = () => (
    <div className="collection-topbar delete-topbar">
        <Link to="/" className="collection-topbar-brand delete-topbar-home">
            <img className="dpp-brand-mark" src={bloomMark} alt="Bloom" />
            <span className="collection-topbar-title">Bloom</span>
        </Link>
    </div>
);

const DeleteAccount = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // When a user deletes from their My Account page, ProfilePage redirects here
    // with the result so this standalone page shows the "Account deleted" screen.
    const initialResult = location.state?.result;
    return (
        <div className="dpp-page dpp-page--short">
            <DeleteHeader />
            <div className="dpp-narrow-page delete-card">
                <DeleteAccountPanel onCancel={() => navigate(-1)} initialResult={initialResult} />
            </div>
        </div>
    );
};

export default DeleteAccount;
